import axios from 'axios';
import { apiURL } from './apiURL';

const privateAPI = axios.create({
  baseURL: apiURL,
  headers: {
    'Content-Type': 'application/json',
  },
});

privateAPI.interceptors.request.use(
  (config) => {
    // console.log(
    // 	"\x1b[36m%s\x1b[0m",
    // 	`${config.method?.toUpperCase() || ""} - ${config.baseURL || ""}/${config.url || ""}`
    // );

    let token: string | null = null;

    if (typeof localStorage !== 'undefined') {
      token = localStorage.getItem('accessToken');
    }
    if (token && config.headers) {
      config.headers.Authorization = `Bearer ${token}`;
    } else {
      delete privateAPI.defaults.headers.common.Authorization;
    }
    return config;
  },
  (error) => Promise.reject(error),
);

export default privateAPI;
